module.exports = __webpack_public_path__ + "img/com.codebeats.followers-staging.be0f8ea0.png";